import { ref, inject, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ce403fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "basicPlanBody"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-desc"
}, "是否允许用户在Google Play商店中延长订阅时长。", -1));
import useDetailHooks from '../hooks/useDetailHooks';
import { getNode } from "@/common";
export default /*#__PURE__*/_defineComponent({
  __name: 'BasicPlanNotAuto',
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const {
      overDateOptions
    } = useDetailHooks();
    const myformRef = ref(null);
    const myform = ref({
      prodBasePlan: {
        planDuration: 'P1D',
        timeExtension: '10'
      }
    });
    const basePlanDurationType = inject('basePlanDurationType');
    watch(() => props.detail, n => {
      if (n && n.prodBasePlan) {
        myform.value = n;
      }
    }, {
      immediate: true,
      deep: true
    });
    // const checker  = () => {
    //   myformRef.value.validate().then(async (valid: any) => {
    //     try {
    //       if (valid) {
    //         return true
    //       }
    //     } catch (error) {
    //       console.log('基本方案notAuto校验失败', error)
    //       return false
    //     }
    //   })
    // } // 校验输入
    // defineExpose({
    //   checker
    // })
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myformRef",
        ref: myformRef,
        model: myform.value,
        "label-col": {
          style: 'width: 114px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "时长",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => {
            var _props$detail;
            return [_createVNode(_component_a_select, {
              class: "inputer",
              value: myform.value.prodBasePlan.planDuration,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => myform.value.prodBasePlan.planDuration = $event),
              options: _unref(basePlanDurationType),
              disabled: __props.disabled || !!((_props$detail = __props.detail) !== null && _props$detail !== void 0 && _props$detail.id),
              getPopupContainer: _unref(getNode)
            }, null, 8, ["value", "options", "disabled", "getPopupContainer"])];
          }),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "允许延期",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: myform.value.prodBasePlan.timeExtension,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => myform.value.prodBasePlan.timeExtension = $event),
            options: _unref(overDateOptions),
            disabled: __props.disabled,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "options", "disabled", "getPopupContainer"]), _hoisted_2]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});